module.exports = __webpack_public_path__ + "static/media/uncheck-icon.34085fff.svg";